export default "__VITE_ASSET__8157OgfO__"